import { clearPermissionCache } from "@/utils/permission";

/** 全部登录字段写完后再打点，其它窗口读到的 token/user 已一致 */
export const SESSION_REV_KEY = "session-identity-rev";

/** 防止 storage / 路由 / 回前台同时触发时重复 reload */
let sessionSyncLocked = false;

/** 同域多窗口通知；storage 在连续 setItem 时可能只看到半写入 */
let sessionChannel = null;

/** 读取当前 localStorage 登录用户 id；无 token 视为未登录 */
function readSessionUserId() {
  if (typeof window === "undefined") {
    return "";
  }
  if (!window.localStorage.getItem("token")) {
    return "";
  }
  // completeLogin 先写 id 再写 user，优先 id 才能在半写入时发现换账号
  const storedId = window.localStorage.getItem("id");
  if (storedId != null && storedId !== "") {
    return String(storedId);
  }
  try {
    const user = JSON.parse(window.localStorage.getItem("user") || "null");
    if (user && user.id != null && user.id !== "") {
      return String(user.id);
    }
  } catch (error) {
    // user JSON 损坏时视为无用户
  }
  return "";
}

/** 本窗口进入时绑定的账号，用来区分「同账号续期」和「其它窗口换账号」 */
let boundUserId = readSessionUserId();

function isAuthExemptRoute() {
  const hash = (window.location && window.location.hash) || "";
  return hash.startsWith("#/login") || hash.startsWith("#/team-invite");
}

/** 身份落盘后再通知其它窗口，避免只收到 token、user 仍是旧账号 */
function notifyOtherWindows() {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(
      SESSION_REV_KEY,
      `${boundUserId}:${Date.now()}`,
    );
  } catch (error) {
    // 隐私模式写失败时仍走 BroadcastChannel
  }
  if (sessionChannel) {
    sessionChannel.postMessage({ userId: boundUserId });
  }
}

/** 本窗口登录 / 退出 / 续期后重绑，避免把自己的写入当成跨窗口换账号 */
export function rebindSessionIdentity() {
  const nextUserId = readSessionUserId();
  const identityChanged = nextUserId !== boundUserId;
  boundUserId = nextUserId;
  // 换账号或退出才广播；同账号续期不打扰其它窗口
  if (identityChanged) {
    notifyOtherWindows();
  }
}

/**
 * 其它窗口改了 token/user 时对齐本窗口：换账号整页刷新，退出则回登录页。
 * @returns {boolean} 已触发跳转或刷新时为 true，调用方应中断后续逻辑
 */
export function syncSessionIdentity() {
  if (typeof window === "undefined") {
    return false;
  }
  const nextUserId = readSessionUserId();
  if (nextUserId === boundUserId) {
    return false;
  }

  clearPermissionCache();

  // 其它窗口退出：已在登录相关页则只清空绑定
  if (!nextUserId) {
    boundUserId = "";
    if (isAuthExemptRoute()) {
      return false;
    }
    window.location.hash = "#/login";
    return true;
  }

  // 本窗口还没绑过账号（例如停在登录页），只跟上新身份
  if (!boundUserId) {
    boundUserId = nextUserId;
    return false;
  }

  if (sessionSyncLocked) {
    return true;
  }
  sessionSyncLocked = true;
  window.location.reload();
  return true;
}

if (typeof window !== "undefined" && typeof BroadcastChannel !== "undefined") {
  sessionChannel = new BroadcastChannel("comic-ai-session");
  sessionChannel.onmessage = () => {
    syncSessionIdentity();
  };
}
